var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"","title":_vm.$t('lbl_EMPBE_SourcingWall')}}),[_c('div',{staticClass:"container-fluid buyer-request-iframe-wrap"},[(_vm.iframeUrl && _vm.iframeKey)?_c('iframe',{key:_vm.iframeKey,staticClass:"buyer-request-iframe",attrs:{"src":_vm.iframeUrl,"frameborder":"0"}}):_vm._e()])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }